import { useMemo } from 'react';
import { useAppSelector } from '@store/hooks';
import { selectProgram } from '@store/slices/programSlice';
import { programRegistry } from 'src/config/programRegistry';
import { ProgramConfig } from 'src/types/programConfig';

// Hook that returns the current banner's ProgramConfig from the registry.

export function useProgramConfig(): ProgramConfig {
  const selectedProgram = useAppSelector(selectProgram);

  return useMemo(() => {
    return programRegistry[selectedProgram];
  }, [selectedProgram]);
}
